export const CLASS_NAME = 'cst-no-data-skeleton-page'
